import React from "react";
import Modal from "./Modal";
import Select from "./Select";

class CitationGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      copyStatus: null
    };
  }

  copyText() {
    clearTimeout(this.copyStatusTimeout);

    // TODO! dry up / consolidate with CiteThisPage
    try {
      const $textarea = $(this.textarea);
      $textarea.show();
      $textarea[0].focus();
      $textarea[0].select();
      document.execCommand("copy");
      $textarea.blur();
      $textarea.hide();
      this.setState({ copyStatus: "Copied!" });
    } catch (_e) {
      this.setState({ copyStatus: "Error!" });
    } finally {
      this.copyStatusTimeout = setTimeout(
        () => this.setState({ copyStatus: null }),
        1000
      );
    }
  }

  render() {
    const { heading, html, text } = this.props;
    const { copyStatus } = this.state;

    return (
      <div className="group">
        <div className="heading">{heading}</div>
        {/* eslint-disable-next-line react/no-danger -- citation content is server-rendered HTML */}
        <div className="well" dangerouslySetInnerHTML={{ __html: html }} />
        <div className="text-center">
          <button
            className="btn btn-primary btn-lg copy"
            onClick={() => this.copyText()}
            type="button"
          >
            {copyStatus || "Copy to Clipboard"}
          </button>
        </div>
        <textarea
          ref={(el) => {
            this.textarea = el;
          }}
          value={text}
          readOnly
          style={{ display: "none" }}
        />
      </div>
    );
  }
}

export default class CiteThisQuoteModal extends React.Component {
  static defaultProps = {
    showOnMount: true
  };

  constructor(props) {
    super(props);

    this.state = {
      loadError: null,
      loaded: false
    };
  }

  componentDidMount() {
    if (this.props.formats && this.props.formats.length > 0) {
      this.setState({
        formatIndex: 0,
        formats: this.props.formats,
        loaded: true
      });
    } else if (this.props.url) {
      $.ajax({
        url: this.props.url
      })
        .done((data) => {
          this.setState({
            formatIndex: 0,
            formats: data.formats,
            loaded: true
          });
        })
        .fail(() => {
          this.setState({
            loadError:
              "Error loading citation data! Please refresh the page and try again.",
            loaded: true
          });
        });
    } else {
      this.setState({
        formatIndex: 0,
        formats: this.props.formats,
        loaded: true
      });
    }
  }

  renderCitationGroup(heading, html, text) {
    return (
      <CitationGroup heading={heading} html={html} key={heading} text={text} />
    );
  }

  renderFormat(index) {
    return (
      <div className="citation">
        {this.state.formats[index].citations.map((c) =>
          this.renderCitationGroup(c.heading, c.html, c.text)
        )}
      </div>
    );
  }

  renderContent() {
    if (!this.state.loaded) {
      return null;
    }

    const { formatIndex, formats, loadError } = this.state;

    if (loadError) {
      return <div className="text-danger">{loadError}</div>;
    }

    return (
      <div>
        <div style={{ marginBottom: 4 }}>Choose citation style:</div>
        <div className="form-group">
          <Select
            id="cite-this-quote__select"
            name="format"
            onChange={({ _label, value }) =>
              this.setState({ formatIndex: value })
            }
            options={formats.map((f, i) => ({ label: f.name, value: i }))}
            value={formatIndex}
          />
        </div>
        {this.renderFormat(formatIndex)}
      </div>
    );
  }

  render() {
    // eslint-disable-next-line react/no-unstable-nested-components
    const Footer = () => (
      <button
        className="btn btn-default btn-md"
        data-dismiss="modal"
        type="button"
      >
        Close
      </button>
    );
    return (
      <Modal
        title="Cite This Quote"
        id={this.props.modalId}
        onHidden={this.props.onHidden}
        footer={<Footer />}
        showOnMount={this.props.showOnMount}
      >
        {this.renderContent()}
      </Modal>
    );
  }
}
